import { useEffect, useState } from 'react';
function useElementWidthObserver(elementRef) {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }
    const resizeObserver = new ResizeObserver(([entry]) => {
      window.requestAnimationFrame(() => {
        const elementWidth = entry.contentRect.width;
        setWidth(elementWidth);
      });
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.unobserve(element);
      resizeObserver.disconnect();
    };
  }, [elementRef]);
  return width;
}
export default useElementWidthObserver;